export const REPORT_SUBMITTED_SUCCESS = "Report submitted!"